import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "snf-shell"
}
const _hoisted_2 = { class: "snf-content" }
const _hoisted_3 = { class: "sl-stage" }
const _hoisted_4 = { class: "sl-brand" }
const _hoisted_5 = { class: "sl-brand-logo-wrap" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "sl-brand-name"
}
const _hoisted_8 = { class: "sl-brand-byline" }
const _hoisted_9 = {
  key: 0,
  class: "sl-alert sl-alert--warn"
}
const _hoisted_10 = {
  key: 1,
  class: "sl-alert sl-alert--offline"
}
const _hoisted_11 = {
  key: 2,
  class: "sl-inner"
}
const _hoisted_12 = { class: "sl-field" }
const _hoisted_13 = { class: "sl-field" }
const _hoisted_14 = { class: "sl-keep" }
const _hoisted_15 = {
  key: 0,
  class: "sl-error"
}
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.systemNotFound)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5",
            opacity: ".35"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "8",
              x2: "12",
              y2: "12"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "16",
              x2: "12.01",
              y2: "16"
            })
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "Essa obra não existe.", -1)),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
          }, "Ir para o início")
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "sl-root",
        style: _normalizeStyle(_ctx.rootVars)
      }, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.systemLogoUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$resolveUrl(_ctx.systemLogoUrl),
                    alt: "logo da obra",
                    class: "sl-brand-logo"
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.systemTitle), 1))
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.logoText), 1)
          ]),
          (_ctx.isSuspended)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("svg", {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round"
                }, [
                  _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "9",
                    x2: "12",
                    y2: "13"
                  }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "17",
                    x2: "12.01",
                    y2: "17"
                  })
                ], -1),
                _createElementVNode("span", null, "Esta obra está suspensa. Apenas administradores podem acessar.", -1)
              ]))]))
            : (_ctx.isOffline && _ctx.isOfflineModeEnabled())
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 20 20",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M1 1l18 18M16.72 11.06A10.94 10.94 0 0 1 19 12.55M5 12.55a10.94 10.94 0 0 1 5.17-2.39M10.71 5.05A16 16 0 0 1 22.56 9M1.42 9a15.91 15.91 0 0 1 4.7-2.88M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, "Sem conexão"),
                    _createElementVNode("span", null, "O login não está disponível offline. Conecte-se à internet para entrar.")
                  ], -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "sl-form-head" }, [
                    _createElementVNode("h2", null, "Entrar"),
                    _createElementVNode("p", null, "Acesse sua conta.")
                  ], -1)),
                  _createElementVNode("form", {
                    class: "sl-form",
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", { for: "sl-user" }, "Usuário", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "sl-user",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
                        type: "text",
                        placeholder: "Ex.: joao.silva",
                        autocomplete: "username"
                      }, null, 512), [
                        [_vModelText, _ctx.username]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", { for: "sl-pw" }, "Senha", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "sl-pw",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                        type: "password",
                        placeholder: "••••••••",
                        autocomplete: "current-password"
                      }, null, 512), [
                        [_vModelText, _ctx.password]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keepLoggedIn) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.keepLoggedIn]
                      ]),
                      _cache[12] || (_cache[12] = _createTextVNode(" Manter logado ", -1))
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.error), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "sl-submit",
                      type: "submit",
                      disabled: _ctx.loading
                    }, _toDisplayString(_ctx.loading ? 'Entrando…' : 'Entrar'), 9, _hoisted_16),
                    _createElementVNode("button", {
                      class: "sl-forgot",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)))
                    }, " Esqueci minha senha ")
                  ], 32)
                ]))
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("footer", { class: "sl-footer" }, [
          _createElementVNode("span", { class: "sl-pulse" }),
          _createElementVNode("span", null, "ObraTycoon")
        ], -1))
      ], 4))
}